import { apiService } from '@/app/platform/core/api/api.service.ts';

import {
  UserBookmark,
  UserBookmarkUpdate,
  UserBookmarksResponse,
} from './types.ts';

export const userBookmarksService = {
  getBookmarks: (): Promise<UserBookmarksResponse> =>
    apiService.get<UserBookmarksResponse>('/features/bookmarks'),

  addBookmark: (
    pagePath: string,
    pageTitle: string,
    description: string | null,
    colorText: string | null,
    colorBackground: string | null,
  ): Promise<UserBookmark> =>
    apiService.post<UserBookmark>('/features/bookmarks', {
      page_path: pagePath,
      page_title: pageTitle,
      description,
      color_text: colorText,
      color_background: colorBackground,
    }),

  updateBookmark: (
    bookmarkId: string,
    data: UserBookmarkUpdate,
  ): Promise<UserBookmark> =>
    apiService.put<UserBookmark>(`/features/bookmarks/${bookmarkId}`, {
      page_title: data.page_title,
      description: data.description,
      color_text: data.color_text,
      color_background: data.color_background,
    }),

  removeBookmark: (bookmarkId: string): Promise<void> =>
    apiService.delete<void>(`/features/bookmarks/${bookmarkId}`),

  reorderBookmarks: (orderedIds: string[]): Promise<UserBookmarksResponse> =>
    apiService.put<UserBookmarksResponse>('/features/bookmarks/order', {
      ordered_ids: orderedIds,
    }),
};
